import commonMixin from '@/mixins/templates/common';

export default {
  name   : 'TopicGroupCompletion',
  mixins : [commonMixin],
  props  : {
    isOpen: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      showModal            : false,
      isCongratsModalOpen  : true,
      selectedModalStyle   : null,
      availableModalStyles : []
    };
  },
  watch: {
    isOpen(value) {
      if (value) {
        const randomStyleId = Math.floor(Math.random() * this.availableModalStyles.length);
        this.selectedModalStyle = this.availableModalStyles[randomStyleId];
      } else {
        this.selectedModalStyle = null;
      }
      this.showModal = value;
    }
  },
  mounted() {
    this.availableModalStyles = [
      {
        id    : 0,
        title : this.$t('content.topicNavigation.congratsModal.title1'),
        image : {
          src            : require('~/assets/img/completion-modals/trophy.svg'),
          alt            : this.$t('content.topicNavigation.congratsModal.alt1'),
          customImgClass : 'trophy animate-translate'
        },
        message          : this.$t('content.topicNavigation.congratsModal.message1'),
        customBtnClass   : 'ml-auto mb-8',
        customTitleClass : 'mt-14'
      },
      {
        id    : 1,
        title : this.$t('content.topicNavigation.congratsModal.title1'),
        image : {
          src            : require('~/assets/img/completion-modals/medal-badge.svg'),
          alt            : this.$t('content.topicNavigation.congratsModal.alt2'),
          customImgClass : 'gold-medal mx-auto animate-zoom-out'
        },
        message          : this.$t('content.topicNavigation.congratsModal.message2'),
        customBtnClass   : 'mx-auto mt-8',
        customTitleClass : 'highlighted mb-6 mt-11'
      },
      {
        id    : 2,
        title : null,
        image : {
          src            : require(`~/assets/img/completion-modals/congrats-banner.svg`),
          alt            : this.$t('content.topicNavigation.congratsModal.alt3'),
          customImgClass : 'congrats-banner mx-auto mb-9 animate-zoom-out'
        },
        message          : this.$t('content.topicNavigation.congratsModal.message3'),
        customBtnClass   : 'mx-auto mt-13',
        customTitleClass : null
      },
      {
        id    : 3,
        title : this.$t('content.topicNavigation.congratsModal.title2'),
        image : {
          src            : require('~/assets/img/completion-modals/festive-stamp.svg'),
          alt            : this.$t('content.topicNavigation.congratsModal.alt4'),
          customImgClass : 'festive-stamp mx-auto mb-6 animate-zoom-out'
        },
        message          : this.$t('content.topicNavigation.congratsModal.message4'),
        customBtnClass   : 'mx-auto mt-7',
        customTitleClass : 'small mb-4'
      }
    ];
  },
  methods: {
    close() {
      this.$emit('close');
    },
    nextContent() {
      this.$emit('nextContent');
    }
  }
};
